import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function GiteIcon(props: IconProps) {
    return <Icon {...props} iconKey={"gite"}/>
}
